/**
 * log — madre del prefijo de consola (orden 21749c65 DEVTOOLS-LIMPIA).
 *
 * TODO console.* propio del front sale por aquí con el prefijo `AARPIA ·`, de modo
 * que el filtro positivo "AARPIA" en DevTools muestre SOLO lo nuestro de un gesto.
 * Los volcados estructurados del bus (asyncapi-devtools) ya llevan el prefijo en sus
 * group headers; este helper iguala el resto (warns/errors sueltos de componentes).
 *
 * Lo que NO puede hacer una página: suprimir los logs de las extensiones del navegador
 * (contentscript.js, ObjectMultiplex…) — hablan en su propio contexto. Para eso está
 * el filtro negativo persistente de DevTools (ver GUIA_CONSOLA_LIMPIA.md).
 */
export const PREFIJO_AARPIA = 'AARPIA ·'

/* eslint-disable no-console */
export const logAarpia = {
  info(mensaje: string, ...resto: unknown[]) { console.info(`${PREFIJO_AARPIA} ${mensaje}`, ...resto) },
  warn(mensaje: string, ...resto: unknown[]) { console.warn(`${PREFIJO_AARPIA} ${mensaje}`, ...resto) },
  error(mensaje: string, ...resto: unknown[]) { console.error(`${PREFIJO_AARPIA} ${mensaje}`, ...resto) },
}
/* eslint-enable no-console */
